
export const ONCALL = "ONCALL";
export const RTCPROCESS = "RTCPROCESS"
export const RTCFAILED = "RTCFAILED"
export const RTCENDED = "RTCENDED"
export const SET_WEBRTCSTATUS ="SET_WEBRTCSTATUS"
export const SET_SHOWCALLLOGPAGE ="SET_SHOWCALLLOGPAGE"
export const SET_AGENTSTATUS ="SET_AGENTSTATUS"
export const AGENT_READY_STATUS = "AGENT_READY_STATUS"
export const SET_LIVEAGENT_DATA = "SET_LIVEAGENT_DATA"